import { render, staticRenderFns } from "./AddKgdPrice.vue?vue&type=template&id=3bc4f789&scoped=true"
import script from "./AddKgdPrice.vue?vue&type=script&lang=js"
export * from "./AddKgdPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4f789",
  null
  
)

export default component.exports